import React from 'react';

const SEABusinessData: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "3B Consulting",
    "alternateName": "3B",
    "description": "Leading IT Consulting and Software Development company in Vietnam and Southeast Asia, specializing in AI, software development, and business transformation",
    "url": "https://3bconsulting.com",
    "logo": "https://3bconsulting.com/assets/3b.png",
    "foundingDate": "2020",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "VN",
      "addressRegion": "Vietnam",
      "addressLocality": "Ho Chi Minh City"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English", "Vietnamese"]
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "Vietnam"
      },
      {
        "@type": "Country", 
        "name": "Thailand"
      },
      {
        "@type": "Country",
        "name": "Singapore"
      },
      {
        "@type": "Country",
        "name": "Malaysia"
      },
      {
        "@type": "Country",
        "name": "Indonesia"
      },
      {
        "@type": "Country",
        "name": "Philippines"
      }
    ],
    "serviceType": [
      "Software Development",
      "IT Consulting", 
      "AI Solutions",
      "Business Transformation",
      "Technology Consulting"
    ],
    "keywords": "3B Consulting, 3B, Software Development, IT Consulting, AI, Vietnam, Southeast Asia"
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default SEABusinessData;
